import { Link, Box, Grid, MenuItem, MenuList, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { IELink } from '../../common/components/IELink';
import { useHistory } from 'react-router';
import { AccessibilityDropdownStyles } from '../../common/styles/accessibilityDropdown';
import { AccessibilityThemes, AccessibilityThemesProps, apiUrls, routeMappings, SessionStore } from '../../constants';
import updateTemplateWithAccessibilitySettings from '../../authentication/utils/updateTemplateWithAccessibilitySettings';
import axios from '../../common/utils/interceptor';
import { templateProvider } from '../../redux-store/providers/templateProvider';
import { useAppSelector } from '../../redux-store/hook';

interface AccessibilityDropDownListProps {
  setOpenAccessibilityMenu: React.Dispatch<React.SetStateAction<boolean>>;
  closeDrawer?: (status: boolean) => void;
}

const AccessibilityDropdownList = (props: AccessibilityDropDownListProps): JSX.Element => {
  const { t } = useTranslation();
  const { setTemplate } = templateProvider();

  const { setOpenAccessibilityMenu, closeDrawer } = props;
  const selectedAccessibilityTheme = sessionStorage.getItem(SessionStore.selectedAccessibilityTheme);
  const [selectedTheme, setSelectedTheme] = useState(
    (selectedAccessibilityTheme && JSON.parse(selectedAccessibilityTheme)) || 1,
  ); // default theme
  const template = useAppSelector((state) => state.template);
  const { settings } = template;
  const history = useHistory();
  const accessibilityDropdown = AccessibilityDropdownStyles(settings);
  const defaultTemplate = useAppSelector((state) => state.defaultTemplate);

  const handleThemeChange = (themeObj: AccessibilityThemesProps) => (): void => {
    const selectedAccessibilityTheme = sessionStorage.getItem(SessionStore.selectedAccessibilityTheme) || '1';
    if (parseInt(selectedAccessibilityTheme) !== themeObj.id) {
      axios.put(apiUrls.UPDATE_WORKFLOW_METADATA, { colorContrast: themeObj.id });
      setSelectedTheme(themeObj.id);
      setTemplate(updateTemplateWithAccessibilitySettings(template, themeObj, defaultTemplate));
      const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);
      if (workflowSession) {
        const parsedWorkflowSession = JSON.parse(workflowSession);
        parsedWorkflowSession.colorContrast = themeObj.id;
        sessionStorage.setItem(SessionStore.workflowSession, JSON.stringify(parsedWorkflowSession));
      }
    }
  };

  const openAccessibilityInformationPage = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
    event.preventDefault();
    closeDrawer && closeDrawer(true);
    setOpenAccessibilityMenu(false);
    history.push(routeMappings['ACCESSIBILITY_INFO']);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={accessibilityDropdown.accessibilityMenuCaption}>
          {t('accessibilityContrastSetting')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <MenuList className={accessibilityDropdown.accessibilityList}>
          {AccessibilityThemes.map((item, idx) => {
            return (
              <MenuItem key={idx} className={accessibilityDropdown.listItem} button tabIndex={0} role="button">
                <Box
                  onClick={handleThemeChange(item)}
                  style={{ backgroundColor: item.secondaryColor }}
                  className={accessibilityDropdown.accessibilityOption}>
                  <Typography
                    style={{ color: item.primaryColor }}
                    className={accessibilityDropdown.accessibilityMenuCaption}>
                    <strong>{t(item.label)}</strong>
                  </Typography>
                  <Box>
                    <input
                      type="radio"
                      className={accessibilityDropdown.accessibilityRadio}
                      name="accessibilityRadio"
                      checked={item.id === selectedTheme}
                    />
                  </Box>
                </Box>
              </MenuItem>
            );
          })}
        </MenuList>
        <Typography>
          <Link
            component={RouterLink}
            to=""
            className={accessibilityDropdown.accessibilityMenuCaption}
            onClick={openAccessibilityInformationPage}>
            <IELink>{t('accessibilityAccomodation')}</IELink>
          </Link>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AccessibilityDropdownList;
